import {IListData} from '../../models/iapi';

export class ListDataResponse<T> implements IListData<T> {
  constructor(public list: T[] = [], public total: number = 0) {
  }
}
